module.exports = __webpack_public_path__ + "static/media/service4.00bb3b26.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Services/images/service4.png
// module id = 438
// module chunks = 0